/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
import { run  } from './CrownMeshViewer';

run(document.getElementById('viewer'));
